'use client';

import { useIntl } from 'react-intl';

export const Verified = () => {
  const { formatMessage } = useIntl();

  return (
    <span className="text-color-success-dark text-size-body-xs inline-flex items-center gap-0.5 font-bold">
      {formatMessage({
        id: 'customerReviews.verified',
        defaultMessage: 'verifizierter Kauf',
      })}
      <span className="icon-emp-checkmark size-2" aria-hidden="true" />
    </span>
  );
};
